import { Component, ElementRef, ViewChild, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { ProfileInfoDto } from 'src/app/shared/interfaces/profile/profile';
import { AvatarService } from 'src/app/shared/services/utilities/avatar-service.service';
import { selectProfile } from 'src/app/shared/state/profile/profile.selectors';
import { selectSubscription, selectTrialDaysRemaining } from 'src/app/shared/state/subscription/subscription.selectors';
import { SubscriptionStatusResponse } from 'src/app/shared/interfaces/stripe/stripe-interface';
import { ToastServiceService } from 'src/app/shared/services/toast-service.service';
import { UserPermissionService } from 'src/app/shared/services/user-permission.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html',
  styleUrls: ['./app.topbar.component.scss'],
})
export class AppTopbarComponent implements OnInit, OnDestroy {
  @ViewChild('menubutton') menuButton!: ElementRef;
  @ViewChild('notificationPanel') notificationPanel!: OverlayPanel;
  avatarBase64 = '';
  trialDaysRemaining: number | null = null;
  subscriptionStatus: SubscriptionStatusResponse | null = null;
  canViewNotifications = false;
  private subscriptions: Subscription[] = [];

  constructor(
    public layoutService: LayoutService,
    private cdr: ChangeDetectorRef,
    private store: Store,
    private avatarService: AvatarService,
    private toastService: ToastServiceService,
    private userPermissionService: UserPermissionService,
    private router: Router
  ) {}

  // Wait until the user is authenticated, then load the avatar once.
  ngOnInit() {
    this.store.select(selectProfile).subscribe((profile: ProfileInfoDto | null) => {
      this.avatarBase64 = this.avatarService.processAvatar(profile?.avatar);
    });

    // Subscribe to subscription status from store
    const subscriptionSub = this.store.select(selectSubscription).subscribe((status: SubscriptionStatusResponse | null) => {
      this.subscriptionStatus = status;
      this.cdr.detectChanges();
    });

    // Subscribe to trial days remaining from store
    const trialDaysSub = this.store.select(selectTrialDaysRemaining).subscribe((days: number | null) => {
      this.trialDaysRemaining = days;
      this.cdr.detectChanges();
    });

    const notificationViewSub = this.userPermissionService.notificationView().subscribe((canView) => {
      this.canViewNotifications = canView;
      this.cdr.detectChanges();
    });

    this.subscriptions.push(subscriptionSub, trialDaysSub, notificationViewSub);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  onMenuButtonClick() {
    console.log('Menu Button Clicked');
    this.layoutService.onMenuToggle();
  }

  onProfileButtonClick() {
    this.layoutService.showProfileSidebar();
  }
  onNotificationButtonClick(event: Event): void {
    this.notificationPanel.toggle(event);
  }

  onUpgradeButtonClick() {
    // Navigate to subscription pricing page with return URL
    const currentUrl = this.router.url;
    this.router.navigate(['/subscription'], { queryParams: { returnUrl: currentUrl } });
  }
}
